import React, { useMemo, useState } from "react";
import { Box, Typography } from "@mui/material";

import DashboardShell from "../../../../components/DashboardShell";
import useAdminDashboard from "../../../../hooks/useAdminDashboard";
import adminDashboardNav from "./dashboardNav";
import FinanceSection from "./sections/FinanceSection";
import OperationsSection from "./sections/OperationsSection";
import OverviewSection from "./sections/OverviewSection";
import PeopleSection from "./sections/PeopleSection";

const AdminDashboard = () => {
  const [activeSection, setActiveSection] = useState("overview");
  const dashboard = useAdminDashboard();
  const sidebarItems = useMemo(
    () => adminDashboardNav.map((item) => ({ ...item, badge: dashboard.navBadges?.[item.key] || 0 })),
    [dashboard.navBadges]
  );

  return (
    <Box sx={{ width: "100%", textAlign: "left" }}>
      {!!dashboard.message && (
        <Typography variant="caption" color="error" sx={{ display: "block", p: 2, pb: 0 }}>
          {dashboard.message}
        </Typography>
      )}

      <DashboardShell
        title="Admin Workspace"
        items={sidebarItems}
        activeKey={activeSection}
        onSelect={setActiveSection}
        headerless
      >
        {activeSection === "overview" && (
          <OverviewSection loading={dashboard.loading} overview={dashboard.overview} />
        )}
        {activeSection === "operations" && (
          <OperationsSection
            adminUid={dashboard.adminUid}
            busyById={dashboard.busyById}
            contracts={dashboard.contracts}
            contractorProfilesByUid={dashboard.contractorProfilesByUid}
            contractors={dashboard.approvedContractors}
            formatCurrency={dashboard.formatCurrency}
            formatDate={dashboard.formatDate}
            hireRequestContracts={dashboard.hireRequestContracts}
            loading={dashboard.loading}
            manageContractRows={dashboard.manageContractRows}
            onMoveStatus={dashboard.operations.onMoveStatus}
            onApproveMatchedContract={dashboard.operations.onApproveMatchedContract}
            onReturnMatchedContract={dashboard.operations.onReturnMatchedContract}
            onConfirmExternalSignatures={dashboard.operations.onConfirmExternalSignatures}
            onRequestRateChange={dashboard.operations.onRequestRateChange}
            onResolveTimesheet={dashboard.operations.onResolveTimesheet}
            openTimesheets={dashboard.operations.openTimesheets}
            pricingRequests={dashboard.operations.pricingRequests}
            resolveContractorName={dashboard.resolveContractorName}
            resolvePricing={dashboard.operations.resolvePricing}
            resolveUserLabel={dashboard.resolveUserLabel}
            statusColor={dashboard.statusColor}
          />
        )}
        {activeSection === "people" && (
          <PeopleSection
            busyById={dashboard.busyById}
            contractorProfilesByUid={dashboard.contractorProfilesByUid}
            contractors={dashboard.contractors}
            formatCurrency={dashboard.formatCurrency}
            loading={dashboard.loading}
            onReviewContractor={dashboard.people.onReviewContractor}
          />
        )}
        {activeSection === "finance" && (
          <FinanceSection
            busyById={dashboard.busyById}
            formatCurrency={dashboard.formatCurrency}
            formatDate={dashboard.formatDate}
            invoices={dashboard.finance.invoices}
            loading={dashboard.loading}
            onApprove={dashboard.finance.onApprove}
            onMoveToProcessing={dashboard.finance.onMoveToProcessing}
            resolveContractorName={dashboard.resolveContractorName}
          />
        )}
      </DashboardShell>
    </Box>
  );
};

export default AdminDashboard;
